import create from '@verndale/core';
import modules from './modules';

document.addEventListener('DOMContentLoaded', () => {
  // Wrap all rtf tables to make them scrollable on mobile
  _$$('.rtf').forEach(rtf => {
    rtf._$$('table').forEach(table => {
      const div = document.createElement('div');
      div.classList.add('table-wrapper');
      rtf.insertBefore(div, table);
      div.append(table);
    })
  });
  create(modules);
});
